// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* twapSummary.css */
.twap-summary {
    background: var(--card-background-color);
    border-radius: var(--home-border-radius);
    box-shadow: var(--home-shadow);
    /* padding: 20px; */
    margin: 20px 0;
}

.total-twaps {
    text-align: center;
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid rgba(0, 36, 117, 0.1);
}

.total-label {
    font-size: 14px;
    color: var(--text-color);
    margin-bottom: 5px;
    font-family: var(--app-font-family);
}

.total-value {
    font-size: 28px;
    font-weight: 500;
    color: var(--primary-color);
    font-family: var(--app-font-family);
}

.summary-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
}

.summary-item {
    padding: 15px;
    border: 1px solid black;
}

.summary-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.summary-label {
    font-size: 14px;
    color: var(--text-color);
    font-family: var(--app-font-family);
}

.count {
    font-size: 14px;
    font-weight: 500;
    padding: 2px 8px;
    border-radius: 12px;
    font-family: var(--app-font-family);
}

.buy-count {
    background: rgba(0, 184, 148, 0.1);
    color: #00b894;
}

.sell-count {
    background: rgba(255, 118, 117, 0.1);
    color: #ff7675;
}

.summary-value {
    font-size: 24px;
    font-weight: 500;
    font-family: var(--app-font-family);
}

.buy-value {
    color: #00b894;
}

.sell-value {
    color: #ff7675;
}

@media (max-width: 768px) {
    .summary-grid {
        grid-template-columns: 1fr;
    }

    .summary-value {
        font-size: 20px;
    }

    .total-value {
        font-size: 24px;
    }
}

.progress-section {
    margin-top: 20px;
    padding-top: 15px;
    border-top: 1px solid rgba(0, 36, 117, 0.1);
}

.status-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.status-label {
    font-size: 14px;
    color: var(--text-color);
    font-family: var(--app-font-family);
}

.status-value {
    font-size: 14px;
    font-weight: 500;
    color: var(--text-color);
    font-family: var(--app-font-family);
}

.progress-bar {
    height: 4px;
    background: rgba(0, 36, 117, 0.05);
    border-radius: 2px;
    display: flex;
    overflow: hidden;
    margin-top: 8px;
}

.progress-fill {
    height: 100%;
    transition: width 0.3s ease;
}

.progress-fill.buy-complete {
    background: #00b894;
}

.progress-fill.buy-pending {
    background: rgba(0, 184, 148, 0.3);
}

.progress-fill.sell-complete {
    background: #ff7675;
}

.progress-fill.sell-pending {
    background: rgba(255, 118, 117, 0.3);
}`, "",{"version":3,"sources":["webpack://./src/styles/twapSummary.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;IACI,wCAAwC;IACxC,wCAAwC;IACxC,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,8CAA8C;AAClD;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,kBAAkB;IAClB,mCAAmC;AACvC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,mCAAmC;AACvC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,mCAAmC;AACvC;;AAEA;IACI,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mCAAmC;AACvC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,mCAAmC;AACvC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,mCAAmC;AACvC;;AAEA;IACI,WAAW;IACX,kCAAkC;IAClC,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;AACxC","sourcesContent":["/* twapSummary.css */\n.twap-summary {\n    background: var(--card-background-color);\n    border-radius: var(--home-border-radius);\n    box-shadow: var(--home-shadow);\n    /* padding: 20px; */\n    margin: 20px 0;\n}\n\n.total-twaps {\n    text-align: center;\n    margin-bottom: 20px;\n    padding-bottom: 15px;\n    border-bottom: 1px solid rgba(0, 36, 117, 0.1);\n}\n\n.total-label {\n    font-size: 14px;\n    color: var(--text-color);\n    margin-bottom: 5px;\n    font-family: var(--app-font-family);\n}\n\n.total-value {\n    font-size: 28px;\n    font-weight: 500;\n    color: var(--primary-color);\n    font-family: var(--app-font-family);\n}\n\n.summary-grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 20px;\n}\n\n.summary-item {\n    padding: 15px;\n    border: 1px solid black;\n}\n\n.summary-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 8px;\n}\n\n.summary-label {\n    font-size: 14px;\n    color: var(--text-color);\n    font-family: var(--app-font-family);\n}\n\n.count {\n    font-size: 14px;\n    font-weight: 500;\n    padding: 2px 8px;\n    border-radius: 12px;\n    font-family: var(--app-font-family);\n}\n\n.buy-count {\n    background: rgba(0, 184, 148, 0.1);\n    color: #00b894;\n}\n\n.sell-count {\n    background: rgba(255, 118, 117, 0.1);\n    color: #ff7675;\n}\n\n.summary-value {\n    font-size: 24px;\n    font-weight: 500;\n    font-family: var(--app-font-family);\n}\n\n.buy-value {\n    color: #00b894;\n}\n\n.sell-value {\n    color: #ff7675;\n}\n\n@media (max-width: 768px) {\n    .summary-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .summary-value {\n        font-size: 20px;\n    }\n\n    .total-value {\n        font-size: 24px;\n    }\n}\n\n.progress-section {\n    margin-top: 20px;\n    padding-top: 15px;\n    border-top: 1px solid rgba(0, 36, 117, 0.1);\n}\n\n.status-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 8px;\n}\n\n.status-label {\n    font-size: 14px;\n    color: var(--text-color);\n    font-family: var(--app-font-family);\n}\n\n.status-value {\n    font-size: 14px;\n    font-weight: 500;\n    color: var(--text-color);\n    font-family: var(--app-font-family);\n}\n\n.progress-bar {\n    height: 4px;\n    background: rgba(0, 36, 117, 0.05);\n    border-radius: 2px;\n    display: flex;\n    overflow: hidden;\n    margin-top: 8px;\n}\n\n.progress-fill {\n    height: 100%;\n    transition: width 0.3s ease;\n}\n\n.progress-fill.buy-complete {\n    background: #00b894;\n}\n\n.progress-fill.buy-pending {\n    background: rgba(0, 184, 148, 0.3);\n}\n\n.progress-fill.sell-complete {\n    background: #ff7675;\n}\n\n.progress-fill.sell-pending {\n    background: rgba(255, 118, 117, 0.3);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
